import { useDispatch } from "react-redux";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { RELEASE_STAGES, ReleaseStage, Status } from "./constants";
import { TiVoAppProvider } from "./types";

export async function isProviderUnique(
  id: string | undefined,
  data: Partial<TiVoAppProvider>,
  dispatch: ReturnType<typeof useDispatch>
): Promise<boolean> {
  const fields: [keyof TiVoAppProvider, string][] = [
    ["label", "exactLabel"],
    ["providerId", "providerId"],
  ];
  const fieldsUnique = await Promise.all(
    fields.map(([name, queryParamName]) =>
      (async () => {
        const providers: ApiResponse<TiVoAppProvider[]> = await dispatch(
          apiThatThrows.getTiVoProviders.action({
            queryParams: {
              [queryParamName]: data[name] || "",
            },
          })
        );
        if (id && providers.meta?.total === 1) {
          return providers.results[0].id === id;
        }
        return providers.meta?.total === 0;
      })()
    )
  );
  return fieldsUnique.every((unique) => unique);
}

export function isStatusReleaseStage(status: Status): status is ReleaseStage {
  return RELEASE_STAGES.includes(status as ReleaseStage);
}
